module.exports = {
  social_deduction_games_online: {
    title: 'Juegos de roles ocultos online con amigos | Avalon',
    description:
      'Compara Avalon con Los Hombres Lobo de Castronegro, Secret Hitler y Among Us: navegador o descarga, eliminación y juego con 5–10 amigos.',
    keywords: ['juegos de roles ocultos online'],
    breadcrumbs: [
      {
        to: '/es/',
        title: 'Inicio',
      },
      {
        to: '/es/guides/social-deduction-games-online/',
        title: 'Juegos de roles ocultos online',
      },
    ],
  },
  games_like_secret_hitler: {
    title: 'Juegos similares a Secret Hitler: Avalon online',
    description:
      'Compara Secret Hitler y Avalon: gobiernos frente a equipos de misión, pistas, Merlín y participación. Prueba Avalon en el navegador con tu grupo.',
    keywords: ['juegos similares a Secret Hitler'],
    breadcrumbs: [
      {
        to: '/es/',
        title: 'Inicio',
      },
      {
        to: '/es/guides/social-deduction-games-online/',
        title: 'Juegos de roles ocultos online',
      },
      {
        to: '/es/guides/games-like-secret-hitler/',
        title: 'Juegos similares a Secret Hitler',
      },
    ],
  },
  avalon_vs_werewolf: {
    title: 'Los Hombres Lobo de Castronegro vs Avalon',
    description:
      '¿Juegas a Los Hombres Lobo de Castronegro? Compara Avalon: misiones y votos sin eliminación temprana. Para 5–10 amigos, o aprende con bots.',
    keywords: ['los hombres lobo de castronegro'],
    breadcrumbs: [
      {
        to: '/es/',
        title: 'Inicio',
      },
      {
        to: '/es/guides/social-deduction-games-online/',
        title: 'Juegos de roles ocultos online',
      },
      {
        to: '/es/guides/avalon-vs-werewolf/',
        title: 'Avalon vs Hombres Lobo',
      },
    ],
  },
};
